export default "__VITE_ASSET__1ad94ffc__"